/**
 * score値(0-100)をHSL色空間で連続マッピングし、背景色CSS文字列を返す。
 *
 * マッピング: score 0 → hue 0 (赤), score 50 → hue 60 (黄), score 100 → hue 120 (緑)
 * 出力: `hsla(hue, 60%, 50%, 0.15)` 形式（暗背景で微かに色味が見える低不透明度）
 *
 * @param score - 0-100のスコア値、またはundefined
 * @returns CSS色文字列。scoreがundefinedの場合は `'transparent'`
 */
export function scoreToHslBackground(score: number | undefined): string {
  if (score == null) {
    return 'transparent'
  }

  const clamped = Math.max(0, Math.min(100, score))
  const hue = Math.round(clamped * 1.2)

  return `hsla(${hue}, 60%, 50%, 0.15)`
}
